import { handleActions, combineActions } from 'redux-actions'
import * as rawActions from '../actions'

const defaultState: boolean = false

export default handleActions(
  {
    [combineActions(
      rawActions.apiExportFormToPdf.request,
      rawActions.apiExportFormToCsv.request,
      rawActions.apiExportFormToCustomCsv.request
    ).toString()]() {
      return true
    },
    [combineActions(
      rawActions.apiExportFormToPdf.success,
      rawActions.apiExportFormToPdf.failed,
      rawActions.apiExportFormToCsv.success,
      rawActions.apiExportFormToCsv.failed,
      rawActions.apiExportFormToCustomCsv.success,
      rawActions.apiExportFormToCustomCsv.failed
    ).toString()]() {
      return defaultState
    },
  },
  defaultState
)
